import { isAdminUser } from "../../services/authService";

/**
 * Dev view-mode override is available only in development builds on localhost,
 * unless explicitly enabled via VITE_DEV_VIEW_MODE_ENABLED=1 (for staged testing).
 */
export function isDevViewModeEnabled() {
  if (!import.meta.env.DEV) return false;

  const forced = String(import.meta.env.VITE_DEV_VIEW_MODE_ENABLED || "").trim();
  if (forced === "1" || forced.toLowerCase() === "true") {
    return true;
  }

  if (typeof window === "undefined") return false;

  const host = String(window.location.hostname || "").toLowerCase();
  return host === "localhost" || host === "127.0.0.1" || host === "[::1]";
}

/** DEV VIEW switch + local override — admin session only. */
export function canAdminUseDevViewOverride() {
  return isDevViewModeEnabled() && isAdminUser();
}
